import { css } from '@/styled-system/css';

export const styledTopBannerStyles = css({
  padding: '{spacing.800} {spacing.400}',
  borderTop: '1px solid',
  borderTopColor: 'border.neutral.secondary',
});
